import React, { useEffect, useState } from 'react';
import { batch, useDispatch } from 'react-redux';
import { fetchCards } from 'lib/actions';
import Container from 'components/shared/generic/container/presentational/Container';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import AccountOverview from './AccountOverview';
import { useLocation } from 'react-router-dom';
import { hideModal, showModal } from 'actions/modal';
import { ACCOUNT_SELECT } from 'constants/shared/modalTypes';
import { useGetAccountQuery, useGetAccountsListQuery } from 'lib/services';

const AccountOverviewContainer = () => {
    const dispatch = useDispatch();
    const jwt = localStorage.getItem('accessToken');
    const [showAccountSelect, setShowAccountSelect] = useState(false);
    const {
        data: account,
        isLoading: isAccountLoading,
        error: accountError,
        refetch: refetchAccount,
    } = useGetAccountQuery();
    const {
        data: accounts,
        isLoading: isAccountsLoading,
        error: accountsError,
    } = useGetAccountsListQuery();

    const isLoading = isAccountLoading || isAccountsLoading;
    const error = accountError || accountsError;

    const { pathname } = useLocation();

    useEffect(() => {
        if (pathname !== '/more') {
            refetchAccount();
        }
    }, [pathname, refetchAccount, jwt]);

    useEffect(() => {
        if (!jwt) return;
        batch(() => {
            dispatch(fetchCards());
        });
    }, [jwt, dispatch]);

    return (
        <Container>
            <DataCheck data={account} isLoading={isLoading} error={error}>
                <AccountOverview
                    account={account}
                    handleShowModal={handleShowModal}
                    showAccountSelect={showAccountSelect}
                    accounts={accounts}
                />
            </DataCheck>
        </Container>
    );

    function handleShowModal(e) {
        e.preventDefault();

        setShowAccountSelect(!showAccountSelect);
        dispatch(
            showModal({
                type: ACCOUNT_SELECT,
                props: {
                    handleModalClose: handleModalClose,
                    accounts: accounts,
                    account: account,
                },
            }),
        );
    }

    function handleModalClose(e) {
        e.preventDefault();

        setShowAccountSelect(false);
        dispatch(hideModal());
    }
};

export default AccountOverviewContainer;
